import { render, staticRenderFns } from "./ListProductAppMarket.vue?vue&type=template&id=fa4e506a&scoped=true"
import script from "./ListProductAppMarket.vue?vue&type=script&lang=js"
export * from "./ListProductAppMarket.vue?vue&type=script&lang=js"
import style0 from "./ListProductAppMarket.vue?vue&type=style&index=0&id=fa4e506a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4e506a",
  null
  
)

export default component.exports